import ChevronDownIcon from "@dcl/icons/esm/ui/chevron-down";
import ChevronUpIcon from "@dcl/icons/esm/ui/chevron-up";
import React from "react";
import { getClassNameFactory } from "@dcl/ui";
export var CountrySelectorHeader = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var ariaLabel = _ref.ariaLabel,
      icon = _ref.icon,
      isExpanded = _ref.isExpanded,
      toggleExpand = _ref.toggleExpand,
      expandButtonId = _ref.expandButtonId;
  var getClassName = getClassNameFactory(CountrySelectorHeader.displayName);

  var handleClick = function handleClick(event) {
    event.preventDefault();
    toggleExpand();
  };

  return /*#__PURE__*/React.createElement("button", {
    "aria-expanded": isExpanded,
    "aria-haspopup": "listbox",
    "aria-label": ariaLabel,
    className: getClassName({
      descendantName: "button"
    }),
    id: expandButtonId,
    onClick: handleClick,
    ref: ref,
    type: "button"
  }, icon, /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "toggleIcon"
    }),
    role: "presentation"
  }, isExpanded ? /*#__PURE__*/React.createElement(ChevronUpIcon, null) : /*#__PURE__*/React.createElement(ChevronDownIcon, null)));
});
CountrySelectorHeader.displayName = "CountrySelectorHeader";